import React from 'react';
import { observer, inject } from 'mobx-react';
import { formatCurrency } from 'js/services/Format';
import Row from 'js/components/core/ReviewPanel/Row';
import Label from 'js/components/core/ReviewPanel/Label';
import Content from 'js/components/core/ReviewPanel/Content';
import EditButton from 'js/components/core/ReviewPanel/EditButton';
import Container from './Container';
import Price from './Price';
import Address from './Address';
import SubNotice from './SubNotice';
import AddressLabel from './AddressLabel';

export default inject('page')(
  observer(({ page }) => (
    <>
      {page.is_expired && (
        <Container>
          <Row>
            <Label>EXPIRED</Label>
            <Content>Sorry, this offer has expired and can no longer be accepted</Content>
          </Row>
        </Container>
      )}

      {page.is_declined && (
        <Container>
          <Row>
            <Label>DECLINED</Label>
            <Content>This offer has been declined and can no longer be accepted</Content>
          </Row>
        </Container>
      )}

      {page.offer_failed && (
        <Container>
          <Row>
            <Label>FAILED</Label>
            <Content>{page.order_summary.human_status}</Content>
          </Row>
        </Container>
      )}

      <Container opacity={page.is_expired || page.is_declined || page.offer_failed ? 0.5 : 1}>
        <Row>
          <Label>BUYER</Label>
          <Content>@{page.order_summary.buyer}</Content>
        </Row>

        <Row>
          <Label>ITEM</Label>
          <Content>
            <div>{page.order_summary.title}</div>
            <Price>{formatCurrency(page.order_summary.price)}</Price>
          </Content>
        </Row>

        <Row>
          <Label>SHIPPING</Label>
          <Content>
            <div>{page.shipping}</div>
            <Address>
              <AddressLabel>From</AddressLabel>
              <div>
                {`${page.order_summary.pickup.city}, ${page.order_summary.pickup.state} ${page.order_summary.pickup.zip}`}
              </div>
              <AddressLabel>To</AddressLabel>
              <div>
                {`${page.order_summary.delivery.city}, ${page.order_summary.delivery.state} ${page.order_summary.delivery.zip}`}
              </div>
            </Address>
          </Content>
        </Row>

        <Row hasError={!page.full_name || !page.phone_number} errorColor="#eef2ff" onClick={page.editContact}>
          <Label>CONTACT</Label>
          <Content>
            <div>
              {!page.full_name || !page.phone_number ? (
                'Please enter your contact info'
              ) : (
                <div>
                  <div>{page.full_name}</div>
                  <div>{page.phone_number}</div>
                </div>
              )}
            </div>

            <SubNotice>We need this to contact you in case there are any issues with your shipment.</SubNotice>
          </Content>
          <EditButton />
        </Row>

        {/*<Row hasError={!page.credit_card.isFilledIn} errorColor="#eef2ff" onClick={page.editPaymentMethod}>*/}
        {/*  <Label>CARD</Label>*/}
        {/*  <Content>*/}
        {/*    <CreditCard />*/}
        {/*  </Content>*/}
        {/*  <EditButton />*/}
        {/*</Row>*/}
      </Container>
    </>
  )),
);
